import {
  SET_ACCOUNTS,
  SET_REMARKS,
  SET_CURRENT_ITEM,
  SET_ACCOUNT_REFRESH,
} from '../utils/constants'

const initialState = {
  accounts: [],
  remarks: [],
  currentItem: null,
  isAccRefresh:false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ACCOUNTS:
      return { ...state, accounts: payload }
    case SET_REMARKS:
      return { ...state, remarks: payload }
      case SET_CURRENT_ITEM:
      return { ...state, currentItem: payload }
      case SET_ACCOUNT_REFRESH:
        return { ...state, isAccRefresh: payload }
    default:
      return state
  }
}
